import List from './list' 
import Show from './show' 
import ClientIcon from '@material-ui/icons/EmojiPeople';

export default{
    list: List,
    show: Show,
    icon: ClientIcon,
}